import React from "react";
import { motion } from "@/lib/motion";
import { Cookie, Circle } from "lucide-react";

const WAFERS = [
    { top: "12%", left: "8%", size: 34, delay: 0, dur: 6, rot: -12 },
    { top: "22%", left: "82%", size: 44, delay: 1.2, dur: 7, rot: 18 },
    { top: "62%", left: "6%", size: 28, delay: 0.6, dur: 5.5, rot: 8 },
    { top: "70%", left: "88%", size: 38, delay: 1.8, dur: 6.5, rot: -20 },
    { top: "44%", left: "50%", size: 24, delay: 0.9, dur: 6, rot: 24 },
];

export default function WaferField({ className = "" }) {
    return (
        <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
            {WAFERS.map((w, i) => (
                <motion.div
                    key={i}
                    className="absolute text-banana-deep/60"
                    style={{ top: w.top, left: w.left }}
                    animate={{ y: [0, -16, 0], rotate: [w.rot, w.rot + 8, w.rot] }}
                    transition={{ repeat: Infinity, duration: w.dur, delay: w.delay, ease: "easeInOut" }}
                >
                    {i % 2 === 0 ? <Cookie size={w.size} strokeWidth={1.4} /> : <Circle size={w.size} strokeWidth={1.4} className="text-banana/70" />}
                </motion.div>
            ))}
        </div>
    );
}
